import format from "date-fns/format";

export default function (value, pattern) {
  const date = new Date(value);

  if (isNaN(date)) return "NOT A DATE";

  return format(date, pattern);
}
